import { GetStaticProps } from 'next';
import axios from 'axios';
import { Blog } from 'types';
import { PodCafeCard } from 'components/podCafe/PodCafeCard';
import { Container, Grid, Typography, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { MetaTags } from 'components/common';

type PodCafeHomeProps = {
  blogs: Blog[];
};

const PodCafeHome = ({ blogs }: PodCafeHomeProps) => {
  const theme = useTheme();
  const useStyles = makeStyles({
    podCafeMain: {
      padding: '100px 0px',
      [theme.breakpoints.down('sm')]: {
        padding: [[70, 0]],
        overflow: 'hidden',
        position: 'relative',
      },
      '& h4': {
        textAlign: 'center',
        fontSize: 30,
        fontWeight: 'bold',
        lineHeight: 1,
        letterSpacing: '0.3em',
        paddingBottom: '20px',
      },
      '& p': {
        fontWeight: '300',
        fontSize: '20px',
        lineHeight: '28px',
        textAlign: 'center',
        width: '550px',
        margin: '0 auto',
        color: 'rgba(17,17,17,0.7)',
        [theme.breakpoints.down('sm')]: {
          width: 'initial',
        },
      },
    },
    root: {
      maxWidth: '340px',
      minHeight: '410px',
      borderRadius: '20px',
      cursor: 'pointer',

      '&:hover': {
        boxShadow: '0px 2px 8px 2px rgb(189 189 189 / 20%)',
      },
    },
    media: {
      height: '177px',
      width: '100%',
      marginBottom: '15px',
    },
    cafeCardsBox: {
      display: 'block',
      paddingTop: '60px',
    },
    readMore: {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '20px',
      color: '#008B5E',
      marginTop: '28px',
    },
    comingSoon: {
      backgroundColor: 'rgba(242,255,251,0.98)',
      display: 'flex',
      flexWrap: 'wrap',
      maxWidth: '340px',
      minHeight: '410px',
      borderRadius: '20px',
      cursor: 'pointer',

      '&:hover': {
        boxShadow: '0px 2px 8px 2px rgb(189 189 189 / 20%)',
      },

      [theme.breakpoints.down('md')]: {
        minWidth: '340px',
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: '340px',
      },
      [theme.breakpoints.down(361)]: {
        minWidth: '328px',
      },
      [theme.breakpoints.down(321)]: {
        minWidth: '290px',
      },

      '& span': {
        margin: 'auto',
        fontWeight: 500,
        fontSize: '20px',
        color: '#111111',
      },
    },

    cardContent: {
      paddingTop: '8px',

      '& h5': {
        fontWeight: 500,
        fontSize: '18px',
        lineHeight: '24px',
        marginBottom: '12px',
        color: '#111111',
        height: '50px',
      },

      '& span': {
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        // display: 'block',
        // wordBreak: "break-all",
        color: 'rgba(17, 17, 17, 0.7)',
        display: '-webkit-box',
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
      },
    },
  });
  const classes = useStyles();

  return (
    <>
      <MetaTags
        title="Welcome to POD Cafe"
        description="Weekly tips on angel investing and fundraising."
        imageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}pod-logo.png`}
        url={process.env.NEXT_PUBLIC_FRONTEND_URL!}
        keywords="POD Cafe blogs invest raise fund"
      />
      <div className={classes.podCafeMain}>
        <Container maxWidth="lg">
          <Typography variant="h4">POD CAFE</Typography>
          <Typography variant="body1">
            POD Cafe brings you curated information to help you grow and expand
            your business.
          </Typography>
          <div className={classes.cafeCardsBox}>
            <Grid container spacing={5}>
              {blogs.map((blog) => (
                <PodCafeCard podCafeContent={blog} key={blog.slug} />
              ))}
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};

export default PodCafeHome;

export const getStaticProps: GetStaticProps = async () => {
  const strapiUrl = process.env.STRAPI_URL!;
  const blogs = await axios
    .get<Blog[]>(`${strapiUrl}/blogs?_sort=id:desc`)
    .then((res) => res.data);
  return {
    props: {
      blogs,
    },
  };
};
